<template lang="pug">
  b-col.bt-1(cols="auto")
    b-form-row.align-items-end.mt-3
      b-col(cols="auto")
        input(type="file", accept="image/*", style="display:none;", ref="input_image", @change="imageSelected", multiple)
        input(type="file", accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv", style="display:none;", ref="input_file", @change="fileSelected", multiple)
        input(type="file", accept=".mp4", style="display:none;", ref="input_video", @change="videoSelected", multiple)
        b-dropdown(:variant="blockInputAfter24Hours? 'primary' : 'soft-secondary'", no-caret, id="emoji-icon")
          template(v-slot:button-content)
            plus-icon.icon-sm
          b-dropdown-text.text-secondary Agregar a mensaje
          b-dropdown-item(@click="emojiPicked = true", :disabled="blockInputAfter24Hours")
            .d-flex.align-items-center
              smile-icon.icon-sm
              span.pl-3 Agregar emoji
          b-dropdown-item(@click="$refs.input_file.click()", v-if="$can('read', 'send-files')", :disabled="blockInputAfter24Hours")
            .d-flex.align-items-center
              paperclip-icon.icon-sm
              span.pl-3 Adjuntar archivo
          b-dropdown-item(@click="$refs.input_image.click()", v-if="$can('read', 'send-images')", :disabled="blockInputAfter24Hours")
            .d-flex.align-items-center
              image-icon.icon-sm
              span.pl-3 Adjuntar imagen
          b-dropdown-item(@click="$refs.input_video.click()", :disabled="blockInputAfter24Hours")
            .d-flex.align-items-center
              video-icon.icon-sm
              span.pl-3 Adjuntar video
          div(v-if="$can('read', 'send-payment-link') || $can('read', 'saved-responses')")
            b-dropdown-divider
            b-dropdown-text.text-secondary Generar
            b-dropdown-item(@click="paymentLinkModal = true", v-if="$can('read', 'send-payment-link')", :disabled="blockInputAfter24Hours")
              .d-flex.align-items-center
                dollar-sign-icon.icon-sm
                span.pl-3 Liga de pago
          b-dropdown-item(@click="responsesModal = true", v-if="$can('read', 'saved-responses')", :disabled="blockInputAfter24Hours")
            .d-flex.align-items-center
              message-square-icon.icon-sm
              span.pl-3 Respuestas guardadas
          b-dropdown-divider(v-if="!isForCases || $can('read', 'send-block-connection')")
          b-dropdown-item(:class= "{'bg-soft-primary':blockInputAfter24Hours}", @click="WAtemplates_modal = true", v-if="has_whats_official && $can('read', 'send-whatsapp-templates')")
            .d-flex.align-items-center.hover-primary
              v-icon.icon(name="brands/whatsapp", scale="1")
              span.pl-3 Enviar Whatsapp template
          b-dropdown-item#id(@click="block_modal = true", v-if="$can('read', 'send-block-connection')")
            .d-flex.align-items-center.hover-primary
              git-pull-request-icon.icon-sm
              span.pl-3 Enviar a bloque de flujo
          b-dropdown-item(v-if="!isForCases", @click="case_modal = true")
            .d-flex.align-items-center.hover-primary
              inbox-icon.icon-sm
              span.pl-3 Crear caso
          b-dropdown-divider
          b-dropdown-item(:disabled="disableSendMessage", @click="confirmDiscardMessage")
            .d-flex.align-items-center.hover-danger
              trash-2-icon.icon-sm
              span.pl-3 Descartar mensaje
      b-col
        SlashCommands(v-if="isShown", :isShown="isShown", :container="composerInput", :message="message", @mutableMessage="handleMutableMessage", @mutableContainer="handleMutableContainer", @imagePush="handleImagePush", @filePush="handleFilePush")#slash.position-absolute
        b-form-textarea#user-message-input(
          v-b-tooltip.hover = "blockInputAfter24Hours ? guideMessage : ''", max-rows="5", no-resize, v-model="message", @input="sendTyping", :readonly="blockInputAfter24Hours", :placeholder="showGuideText()", @keydown.enter="$root.$emit('bv::hide::popover', 'emoji-icon');prevSendMessage($event)", autocomplete="off", ref="user-text-input", @focus="$root.$emit('bv::hide::popover', 'emoji-icon')", :class="{short: message.length < 35 && !message.includes('\\n')}")
      b-col(cols="auto")
        b-button(variant="primary", :disabled="disableSendMessage", @click="$root.$emit('bv::hide::popover', 'emoji-icon'); sendMessage()", style="min-height:38px;")
          .d-flex.align-items-center
            b-spinner.mr-2(small, type="grow", v-if="sending_message")
            span.mr-1(v-if="$breakpoint.mdUp") Enviar
            send-icon.icon-sm
      b-col(cols="auto")
        b-button(v-if="!isRecording", variant="soft-primary", @click="recordVoiceMessage()", style="min-height:38px;", :disabled="blockInputAfter24Hours")
          mic-icon.icon-md
        b-button#stopIcon(v-if='isRecording', variant="soft-primary", @click="stopVoiceMessage()", style="min-height:38px;", :disabled="blockInputAfter24Hours")
          stop-circle-icon.icon-md
    b-popover(:show.sync="show_emojis", target="emoji-icon", placement="top", triggers="click")
      template(slot="title")
        .d-flex.align-items-center.justify-content-between
          span Insertar emoji
          x-icon.icon-md.hover-danger.pointer(@click="show_emojis = false")
      picker(set="facebook", :style="{width: '100%', height: '250px', 'border-radius': 0}", v-bind="pickerParams", @select="insertEmoji", :data="emojiIndex", title="Emojis", :i18n="i18n")
    b-modal(:ok-title="paymentLink.confirmPayment ? 'Generar liga' : 'Enviar liga de pago'", :okOnly="paymentLink.confirmPayment", v-model="paymentLinkModal", ok-variant="primary", title="Generar liga de pago", cancel-title="Cancelar", @ok="confirmPayment", @hidden="clearObject(paymentLink)", :ok-disabled="paymentLink_loading")
      b-container
        b-form-group(label="Referencia de pago", description="Concepto o referencia que identificará el pago")
          b-form-input(placeholder="Referencia de pago", v-model.trim="paymentLink.reference", :disabled="paymentLink.confirmPayment")
        b-form-group(label="Monto *", description="El monto total a pagar")
          b-input-group
            b-input-group-prepend
              b-input-group-text
                dollar-sign-icon.icon-sm
            b-form-input(type="number", v-model="paymentLink.amount", placeholder="0.00", :disabled="paymentLink.confirmPayment", :state="paymentLink.validated ? (!isNaN(paymentLink.amount) && paymentLink.amount > 0) : null")
        b-collapse(v-model="paymentLink.confirmPayment", id="paymentLink-collapse")
          b-card.mb-3(style="max-width:300px;")
            p.mb-0 Liga de pago
            p.mb-0(:class="paymentLink.reference ? 'text-secondary' : 'text-help'") {{ paymentLink.reference || 'Sin referencia' }}
            hr
            p.mb-0.text-right.font-weight-bold ${{ priceFormat(paymentLink.amount) }}
          b-link.text-danger.text-sm(@click="paymentLink.confirmPayment = false", v-if="!paymentLink_loading") Editar liga de pago
          b-alert.mb-0.text-sm(:show="paymentLink_loading", variant="primary") Un momento, estamos generando la liga de pago...
    b-modal(size="lg", scrollable, ok-title="Seleccionar", v-model="responsesModal", okOnly, ok-variant="primary", title="Respuestas guardadas", :ok-disabled="!selected_answer", @ok="answerSelected(true)")
      b-container
        p Selecciona una respuesta y da click en "Seleccionar". Se llenará el editor de texto para que puedas revisar la respuesta antes de enviarla.
        b-input-group.mb-3
          b-form-input(placeholder="Buscar respuesta...", v-model="response_search", type="search")
          b-input-group-append
            b-input-group-text
              search-icon.text-secondary.icon-sm
        b-table.card-table.mb-0(:items="response_templates", :fields="fields", responsive, show-empty, selectable, select-mode="single", @row-selected="answerSelected", ref="responses_table", @hidden="clearResponseSelection")
          template(v-slot:empty)
            p.mb-0.text-help No hay respuestas para mostrar
          template(v-slot:cell(text)="{ item }")
            .d-flex
              b-img.mr-3(:src="item.image", v-if="item.image", width="50", height="50", rounded)
              .flex-grow-1
                .d-flex.justify-content-between
                  p.mb-0.bold {{ item.name }}
                  b-badge.ml-1(variant="light", v-if="item.category") {{ item.category }}
                p.mb-0.text-secondary {{ item.text }}
      b-pagination.mt-3.mb-0(v-model="pagination_page", size="sm", v-if="responses_hasNextPage", align="center", :total-rows="100", :per-page="response_pagination.page", @change="pageChange")
    b-modal(v-model="WAtemplates_modal", title="Enviar Whatsapp template", ok-title='Cancelar', ok-variant="secondary", ok-only)
      send-whatsapp-template(:user_id="userId", @sent="WAtemplates_modal = false")
    b-modal(v-model="block_modal", title="Enviar a bloque de flujo", :ok-only="tabIndex == 0", :ok-title="tabIndex == 0 ? 'Cancelar' : 'Enviar'", :ok-variant="tabIndex == 0 ? 'secondary' : 'primary'", cancel-title="Cancelar", @ok="tabIndex == 0 ? block_modal = false : sendToBlock()", @hidden="clearBlocks", :ok-disabled="tabIndex == 0 ? false : !next_block")
      b-container
        b-tabs.mb-4(v-model="tabIndex")
          b-tab(title="Favoritos")
          b-tab(title="Selección")
        div(v-show="tabIndex == 0")
          empty-message(v-if="!favorite_blocks.length", message="No has agregado bloques favoritos")
          b-button.mr-1.mb-1(variant="soft-primary", size="sm", v-for="f_block in favorite_blocks", :key="f_block.block_id" @click="sendFavoriteBlock(f_block.block_id)")
            p.mb-0.text-sm Bloque: {{f_block.name}} ({{f_block.block_id}})
              x-icon.icon-md.hover-danger.pointer.text-secondary.ml-1(@click.stop="updateBlock(f_block.block_id, false)")
            //p.mb-0.text-sm Bloque: Block test (457)
        div(v-show="tabIndex == 1")
          b-form-group(label="Flujos", description="Selecciona el flujo al que pertenecce el bloque")
            b-form-select(v-model="flow_id", @change="getBlocks")
              option(:value="null", disabled) --Selecciona flujo--
              option(v-for="flow in flows", :key="flow.flow_id", :value="flow.flow_id") {{flow.name}}
          b-form-group(label="Bloque")
            b-form-select(v-model="next_block", :disabled="!blocks.length")
              option(:value="null", disabled) --Selecciona bloque--
              option(v-for="block in blocks", :key="block.block_id", :value="block.block_id") {{block.name}}
          .text-right
              b-button(variant="soft-primary", size="sm", :disabled="!next_block", @click="updateBlock(next_block, true)") Agregar a favoritos
    b-modal(v-model="case_modal", centered, title="Crear caso", ok-title="Crear", ok-variant="primary", cancel-title="Cancelar", @ok="createCase", @hidden="group_id = admin_assigned_id = null")
      b-container
        b-form-group(label="Derivar a grupo")
          b-form-select(v-model="group_id")
            option(:value="null") General
            option(v-for="group in groups", :key="group.group_id", :value="group.group_id") {{group.name}}
        b-form-group(label="Asignar administrador")
          k-select(v-model="admin_assigned_id", placeholder="Buscar admin...",  :options="parsed_admins", :clearable="true")
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import debounce from 'lodash.debounce'
import data from 'emoji-mart-vue-fast/data/facebook.json'
import { EventBus } from '@/helpers/eventBus'
import { Picker, EmojiIndex } from 'emoji-mart-vue-fast'
import Select from '../components/Select.vue'
import SendWhatsappTemplate from './SendWhatsappTemplate'
import { toBase64 } from '../helpers/file-converter'
import Validators from '../helpers/data_validators'
import { wrapEmoji } from '../helpers/emojiParser'
import SlashCommands from '../components/SlashCommands.vue'
import { VoiceMessage } from '../helpers/voiceMessage'
import mixpanel from '@/mixpanel'

const accountController = createNamespacedHelpers('account')
const blockController = createNamespacedHelpers('block')
const caseController = createNamespacedHelpers('case')
const emojiIndex = new EmojiIndex(data)
const flowController = createNamespacedHelpers('flow')
const groupController = createNamespacedHelpers('group')
const inboxController = createNamespacedHelpers('inbox')
const platformController = createNamespacedHelpers('platform')
const MEDIA_DEVICES_ERROR = 'mediaDevices API or getUserMedia method is not supported in this browser.'
const RECOMENDATION_ERROR = 'Para grabar notas de voz te recomendamos usar navegadores como Google Chrome o Mozilla Firefox.'
const RECORDING_ERROR = 'Ha ocurrido un error intentando grabar la nota de voz'

export default {
  mixins: [Validators.Methods],
  props: {
    files: {
      type: Array,
      default: function () {
        return []
      }
    },
    userId: {
      default: ''
    },
    platform: {
      type: String,
      default: ''
    },
    isForCases: {
      type: Boolean,
      default: false
    },
    lastMessage: {
      type: Object,
      default: () => ({})
    },
    container: {
      type: HTMLDivElement,
      default: null
    },
    messageToAnswer: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      guideMessage: `Han transcurrido más de 24 horas desde el último mensaje, por favor 
      utiliza una plantilla de WhatsApp si desea contactar al usuario.`,
      isRecording: false,
      voiceMessager: new VoiceMessage(this),
      composerInput: null,
      emojiIndex,
      pickerParams: {
        showSearch: false,
        showCategories: false,
        showPreview: false
      },
      message: '',
      sending_message: false,
      variables_errors: false,
      response_templates: [],
      responsesModal: false,
      fields: [
        {
          key: 'text',
          label: 'Respuesta'
        }
      ],
      show_emojis: false,
      i18n: {
        search: 'Buscar',
        notfound: 'No hay resultados',
        categories: {
          search: 'Búsqueda',
          recent: 'Usados frecuentemente',
          people: 'Caras y personas',
          nature: 'Naturaleza',
          foods: 'Comida y bebidas',
          activity: 'Actividades',
          places: 'Lugares y viajes',
          objects: 'Objetos',
          symbols: 'Símbolos',
          flags: 'Banderas',
          custom: 'Custom'
        }
      },
      response_pagination: {
        limit: 20,
        page: 1
      },
      response_search: '',
      responses_hasNextPage: false,
      paymentLinkModal: false,
      paymentLink: {
        reference: '',
        amount: '',
        confirmPayment: false,
        validated: false
      },
      paymentLink_loading: false,
      selected_answer: null,
      emojiPicked: false,
      block_modal: false,
      flow_id: null,
      next_block: null,
      case_modal: false,
      group_id: null,
      admin_assigned_id: null,
      tabIndex: 0,
      typing: false,
      WAtemplates_modal: false,
      isShown: false
    }
  },
  computed: {
    ...inboxController.mapGetters(['isClientConnected']),
    disableSendMessage() {
      const { message, sending_message, files } = this
      const notHasFiles = !files.length
      const notHasText = !message.trim()

      return sending_message || (notHasFiles && notHasText) || !this.isClientConnected
    },
    ...accountController.mapGetters(['selectedLanguage']),
    ...accountController.mapState({
      admins: (state) => state.admins
    }),
    ...flowController.mapState({
      flows: (state) => state.flows,
      blocks: (state) => state.blocks
    }),
    ...platformController.mapState({
      platforms: (state) => state.platforms,
      accounts: (state) => state.accounts
    }),
    ...groupController.mapState({
      groups: (state) => state.groups
    }),
    ...blockController.mapState({
      favorite_blocks: (state) => state.favorite_blocks
    }),
    ...caseController.mapState({
      case_object: (state) => state.case_object
    }),
    parsed_admins() {
      return this.admins.map((admin) => {
        return {
          label: admin.email,
          id: admin.admin_id
        }
      })
    },
    platform_id() {
      const _platform = this.platforms.find((p) => p.name == this.platform)
      if (_platform) return _platform.platform_id
      return null
    },
    has_whats_official() {
      const names = ['whatsapp_official', 'Whatsapp Official']
      const existWA = this.platforms.find((el) => names.includes(el.name))
      if (!existWA) return false
      return !!existWA.models.length
    },
    blockInputAfter24Hours() {
      const { lastMessage, platform } = this
      const { date: lastMessageDate } = lastMessage || {}
      const lastMessageHoursPassed = this.$moment().diff(
        this.$moment(lastMessageDate),
        'hours'
      )

      return lastMessageHoursPassed >= 24 && platform === 'whatsapp_official'
    },
  },
  methods: {
    ...mapActions([
      'helpers/upload_file',
      'inbox/message',
      'inbox/typing',
      'response_template/all',
      'response_template/search',
      'account/paymentLink',
      'user/updateBotStatus',
      'flow/all',
      'flow/get',
      'message/send',
      'case/create',
      'block/favorites',
      'block/update',
      'conversation/get',
      'helpers/send_audio'
    ]),
    handleMutableMessage(value) {
      this.message = value
    },
    handleMutableContainer(value) {
      this.$refs['user-text-input'].innerHTML = value
    },
    handleImagePush(value) {
      if (value.type !== 'image') return

      this.$emit('files:push', { type: 'image', src: value.src })
    },
    handleFilePush(value) {
      if (value.type !== 'file') return

      this.$emit('files:push', { type: 'file', src: value.src })
    },
    fileSelected(event) {
      mixpanel.track('Composer Input: File Selected', {
        account_id: this.$route.params.account_id,
        unique_id: this.getCurrentUser().email,
        admin_id: this.getCurrentUser().email_id,
        role_id: this.getCurrentUser().role_id
      });
      const files = event.target.files
      $(event.target).attr('value', '')

      if (files.length) {
        // let file = files[0]

        // only 1 file per type allowed by the moment
        // let index = this.files.findIndex(f => f.type == 'file')
        // if (index >= 0) { this.$emit('files:remove', index) }

        for (const file of files) {
          if (file.size / 1000000 >= 25) {
            this.$message.warning(
              `El archivo ${file.name} no debe exceder los 25 megabytes.`
            )
          } else {
            this.$emit('files:push', {
              type: 'file',
              file
            })
          }
        }
      }
    },
    videoSelected(event) {
      mixpanel.track('Composer Input: Video Selected', {
        account_id: this.$route.params.account_id,
        unique_id: this.getCurrentUser().email,
        admin_id: this.getCurrentUser().email_id,
        role_id: this.getCurrentUser().role_id
      });
      const files = event.target.files
      $(event.target).attr('value', '')

      if (files.length) {
        for (const file of files) {
          this.$emit('files:push', {
            type: 'video',
            file
          })
        }
      }
    },
    async confirmDiscardMessage() {
      try {
        mixpanel.track('Composer Input: Discard Message', {
          account_id: this.$route.params.account_id,
          unique_id: this.getCurrentUser().email,
          admin_id: this.getCurrentUser().email_id,
          role_id: this.getCurrentUser().role_id
        });
        const res = await this.$bvModal.msgBoxConfirm(
          '¿Descartar mensaje? Se perderán los datos del editor.',
          {
            title: 'Descartar mensaje',
            okVariant: 'danger',
            okTitle: 'Descartar mensaje',
            cancelTitle: 'Cancelar',
            hideHeaderClose: false
          }
        )

        if (res == true) {
          this.fillComposer(false)
        }
      } catch (e) {
        console.log(e.message)
      }
    },
    imageSelected(event) {
      mixpanel.track('Composer Input: Image Selected', {
        account_id: this.$route.params.account_id,
        unique_id: this.getCurrentUser().email,
        admin_id: this.getCurrentUser().email_id,
        role_id: this.getCurrentUser().role_id
      });
      const files = event.target.files

      $(event.target).attr('value', '')

      if (files.length) {
        // let file = files[0]

        // only 1 file per type allowed by the moment
        // let index = this.files.findIndex(f => f.type == 'image')
        // if (index >= 0) { this.$emit('files:remove', index) }
        for (const file of files) {
          this.$emit('files:push', {
            type: 'image',
            src: URL.createObjectURL(file),
            file
          })
        }
      }
    },
    prevSendMessage(event) {
      if (event && !event.shiftKey) {
        event.preventDefault()
        this.sendMessage()
      }
    },
    async recordVoiceMessage() {
      mixpanel.track('Composer Input: Record Voice Message', {
        account_id: this.$route.params.account_id,
        unique_id: this.getCurrentUser().email,
        admin_id: this.getCurrentUser().email_id,
        role_id: this.getCurrentUser().role_id
      });
      this.isRecording = true

      await this.voiceMessager.start().then(() => {
        this.$message.success('Grabando...')
      }).catch((error) => {
        if (error.message.includes(MEDIA_DEVICES_ERROR)) {
          console.error(error)

          return this.$message.error(RECOMENDATION_ERROR)
        }

        this.$message.error(RECORDING_ERROR)

        switch (error.name) {
          case 'AbortError':
            console.log('An AbortError has occured.')
            break
          case 'NotAllowedError':
            console.log('A NotAllowedError has occured. User might have denied permission.')
            break
          case 'NotFoundError':
            console.log('A NotFoundError has occured.')
            break
          case 'NotReadableError':
            console.log('A NotReadableError has occured.')
            break
          case 'SecurityError':
            console.log('A SecurityError has occured.')
            break
          case 'TypeError':
            console.log('A TypeError has occured.')
            break
          case 'InvalidStateError':
            console.log('An InvalidStateError has occured.')
            break
          case 'UnknownError':
            console.log('An UnknownError has occured.')
            break
          default:
            console.log('An error occured with the error name ' + error.name)
        }
      })
    },
    blobToFileBuffer(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()

        reader.onload = () => { resolve(reader.result) }
        reader.onerror = () => { reject(reader.error) }
        reader.readAsArrayBuffer(blob)
      })
    },
    fileBufferToFileObject(fileBuffer, fileName, fileType) {
      const file = new File([fileBuffer], fileName, { type: fileType })

      return file
    },
    async stopVoiceMessage() {
      try {
        this.isRecording = false
        const audioBlob = await this.voiceMessager.stop()
        this.$message.success('Finalizó la grabación.')

        const fileBuffer = await this.blobToFileBuffer(audioBlob)
        const file = this.fileBufferToFileObject(fileBuffer, 'admin_audio.ogg', 'audio/ogg')
        audioBlob.src = URL.createObjectURL(file)

        this.$emit('files:push', {
          type: 'audio',
          file: audioBlob
        })
      } catch (error) {
        this.$message.error(RECORDING_ERROR)

        switch (error.name) {
          case 'InvalidStateError':
            console.log('An InvalidStateError has occured.')
            break
          default:
            console.log('An error occured with the error name ' + error.name)
        }
      }
    },
    async sendMessage() {
      const self = this

      if (this.disableSendMessage) return

      this.sending_message = true
      const params = {
        account_id: self.$route.params.account_id,
        message: {}
      }

      if (this.isForCases) {
        params.case_id = self.$route.params.case_id
      } else {
        params.platform = self.platform
        params.user_id = self.userId
      }

      if (this.files.length) {
        for (let i = 0; i < this.files.length; i++) {
          const file = this.files[i]

          try {
            switch (file.type) {
              case 'image':
                params.message.image = file.src.match(/^blob:/gim)
                  ? await this.uploadFile(file)
                  : file.src
                break
              case 'audio':
                if (file.file) {
                  params.message.attachment = {
                    type: file.type,
                    url: await this.sendAudio(file)
                  }
                }
                break
              case 'file':
              case 'video':
                if (file.file) {
                  params.message.attachment = {
                    type: file.type,
                    url: await this.uploadFile(file)
                  }
                } else {
                  params.message.attachment = {
                    type: file.type,
                    url: file.src
                  }
                }
                break
            }
            if (i === this.files.length - 1 && self.message) {
              params.message.text = self.message // this.decodeHtml(self.message)
            }

            this.pushMessage(params, i === (this.files.length - 1))
            params.message = {}
          } catch (e) {
            console.error(e.message)

            self.$message.error('Ocurrió un error subiendo archivo')
          }
        }
      } else if (self.messageToAnswer && self.message) {
        params.message.text = self.message
        params.message.textAnswered = self.messageToAnswer.text
        params.wamID = self.messageToAnswer.wamID || self.messageToAnswer.externalId

        this.pushMessage(params, true)
        self.$emit('messageToAnswered', null)
      } else if (self.message) {
        params.message.text = self.message

        this.pushMessage(params, true)
      }
    },
    pushMessage(params, last_message = false) {
      this['inbox/message']({
        ...params,
        callback: (res) => {
          this.sending_message = false

          setTimeout(() => { this.scrollToBottom() }, 400)

          if (res.error) return this.$message.error(res.error)
          if (last_message) {
            this.sending_message = false
            this.message = ''

            if (this.$refs['user-text-input']) { this.$refs['user-text-input'].innerHTML = '' }

            this.$emit('files', [])

            if (!this.isForCases) this.updateBotStatus()
          }
        }
      })
    },
    async sendAudio(file) {
      mixpanel.track('Composer Input: Send Audio', {
        account_id: this.$route.params.account_id,
        unique_id: this.getCurrentUser().email,
        admin_id: this.getCurrentUser().email_id,
        role_id: this.getCurrentUser().role_id
      })

      const self = this

      return new Promise(async (resolve, reject) => {
        const fileBase64 = await toBase64(file.file, true)
        const params = {
          filename: Date.now() + ".webm",
          passTo: 'mp3',
          ext: 'mp3',
          file: fileBase64
        }

        self['helpers/send_audio']({
          params,
          callback: (res) => {
            if (res.error) reject(new Error(res.error))

            resolve(res.resource.url)
          }
        })
      })
    },
    scrollToBottom() {      
      this.container.scroll({
        top: this.container.scrollHeight, behavior: 'smooth'
      })
    },
    answerSelected(answers) {
      mixpanel.track('Composer Input: Answer Selected', {
        account_id: this.$route.params.account_id,
        unique_id: this.getCurrentUser().email,
        admin_id: this.getCurrentUser().email_id,
        role_id: this.getCurrentUser().role_id
      });
      if (answers == true) {
        this.fillComposer(this.selected_answer)
      } else {
        this.selected_answer = answers[0]
      }
    },
    fillComposer(response) {
      if (response == false) {
        this.clearComposer()
      }

      if (response.image) {
        this.clearComposer('files')
        this.$emit('files:push', {
          type: 'image',
          src: response.image
        })
      }

      if (response.file) {
        this.$emit('files:push', {
          type: 'file',
          src: response.file
        })
      }

      if (response.text) {
        this.clearComposer('message')
        this.message = response.text
        this.$refs['user-text-input'].innerHTML = response.text
      }

      if (response.name) {
        this.$message.info(`Editor actualizado con respuesta ${response.name}`)
      }

      if (this.responsesModal) this.responsesModal = false
    },
    clearComposer(type = 'all') {
      if (type == 'all' || type == 'files') {
        this.$emit('files', [])
      }

      if (type == 'all' || type == 'message') {
        this.message = ''
        this.$refs['user-text-input'].innerHTML = ''
      }
    },
    getResponses() {
      const { Group = {} } = this.case_object
      const { group_id: groupId } = Group || {}
      this['response_template/all']({
        account_id: this.$route.params.account_id,
        params: {
          ...this.response_pagination
        },
        callback: (res) => {
          this.hideLoadingScreen()
          if (res.error) return this.$message.error(res.error)
          if (!groupId) this.response_templates = res.resource
          else {
            this.response_templates = res.resource.filter(
              ({ Groups = [] }) =>
                Groups.some(({ group_id }) => group_id == groupId) ||
                !Groups.length
            )
          }
          this.responses_hasNextPage = res.hasNextPage || false
        }
      })
    },
    searchResponse: debounce(function () {
      if (!this.response_search.length) return
      const self = this
      // this.showLoadingScreen()

      this['response_template/search']({
        params: {
          ...self.response_pagination,
          account_id: self.$route.params.account_id,
          search: self.response_search
        },
        callback: (res) => {
          self.hideLoadingScreen()

          if (res.error) return self.$message.error(res.error)

          self.response_templates = res.resource
          self.responses_hasNextPage = res.hasNextPage || false
        }
      })
    }, 700),
    insertEmoji(emoji) {
      this.message += emoji.native
      this.$refs['user-text-input'].innerHTML = wrapEmoji(this.message)

      if (this.$breakpoint.smDown) {
        this.show_emojis = false
      }
    },
    decodeHtml(html) {
      const txt = document.createElement('textarea')
      txt.innerHTML = html.replace(/<span.*?alt="(.*?)".*>/g, '$1')
      return txt.innerText
    },
    confirmPayment(vbModal) {
      if (vbModal) {
        vbModal.preventDefault()
      }

      if (this.paymentLink.confirmPayment) {
        this.generatePaymentLink()
      } else {
        this.paymentLink.validated = false
        if (this.paymentLink.amount <= 0 || isNaN(this.paymentLink.amount)) {
          this.paymentLink.validated = true
          return
        }

        try {
          this.paymentLink.amount = parseFloat(this.paymentLink.amount)
        } catch (e) {
          this.$message.warning('Por favor introduce un monto válido.')
          this.clearObject(this.paymentLink, { number: '' })
        }

        this.paymentLink.confirmPayment = true
      }
    },
    generatePaymentLink() {
      mixpanel.track('Composer Input: Generate Payment Link', {
        account_id: this.$route.params.account_id,
        unique_id: this.getCurrentUser().email,
        admin_id: this.getCurrentUser().email_id,
        role_id: this.getCurrentUser().role_id
      });
      const self = this
      this.paymentLink_loading = true

      this['account/paymentLink']({
        account_id: self.$route.params.account_id,
        ...self.paymentLink,
        user_id: self.userId,
        callback: (res) => {
          self.paymentLink_loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success(
              'Liga de pago generada con éxito y enviada al usuario.'
            )
            self.paymentLinkModal = false
            self.clearObject(self.paymentLink, { number: '' })
          }
        }
      })
    },
    pageChange(page) {
      this.response_pagination.page = page
      /* if(this.response_search){
        this.searchResponse()
      } else {
        this.getResponses()
      } */
    },
    async uploadFile(file) {
      mixpanel.track('Composer Input: Upload File', {
        account_id: this.$route.params.account_id,
        unique_id: this.getCurrentUser().email,
        admin_id: this.getCurrentUser().email_id,
        role_id: this.getCurrentUser().role_id
      });
      const self = this
      return new Promise(async (resolve, reject) => {
        const params = {
          file_name: file.file.name || '',
          mime: file.file.type || ''
        }

        try {
          if (file.file.name.includes('.')) {
            params.file_extension = file.file.name.split('.').slice(-1)
          }
        } catch (e) {
          console.log(e.message)
        }

        try {
          const fileBase64 = await toBase64(file.file, true)
          params.file = fileBase64
        } catch (e) {
          console.log(e.message)
          reject(new Error('Error cargando archivo'))
        }

        self['helpers/upload_file']({
          ...params,
          callback: (res) => {
            if (res.error) {
              reject(new Error(res.error))
            } else {
              resolve(res.resource.url)
            }
          }
        })
      })
    },
    clearResponseSelection() {
      if (this.$refs.responses_table) {
        this.$refs.responses_table.clearSelected()
      }
    },
    updateBotStatus() {
      mixpanel.track('Composer Input: Update Bot Status', {
        account_id: this.$route.params.account_id,
        unique_id: this.getCurrentUser().email,
        admin_id: this.getCurrentUser().email_id,
        role_id: this.getCurrentUser().role_id
      })
      EventBus.$emit(
        'conversationId',
        {
          _id: this.$route.params.conversation_id,
          bot_enabled: false
        }
      )

      this['user/updateBotStatus']({
        account_id: this.$route.params.account_id,
        platform: this.platform,
        bot_enabled: false,
        user_id: this.userId,
        callback: (res) => {
          if (res.error) return this.$message.error(res.error)
        }
      })
    },
    getBlocks() {
      const self = this
      this['flow/get']({
        flow_id: self.flow_id,
        callback: (res) => {
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    },
    clearBlocks() {
      this.flow_id = this.next_block = null
      this.$store.commit('flow/setBlocks', [])
      this.tabIndex = 0
    },
    sendFavoriteBlock(blockId) {
      mixpanel.track('Composer Input: Send Favorite Block', {
        account_id: this.$route.params.account_id,
        unique_id: this.getCurrentUser().email,
        admin_id: this.getCurrentUser().email_id,
        role_id: this.getCurrentUser().role_id
      });
      this.next_block = blockId

      this.sendToBlock()
    },
    sendToBlock() {
      mixpanel.track('Composer Input: Send To Block', {
        account_id: this.$route.params.account_id,
        unique_id: this.getCurrentUser().email,
        admin_id: this.getCurrentUser().email_id,
        role_id: this.getCurrentUser().role_id
      });
      const params = {
        account_id: this.$route.params.account_id,
        language_id: this.selectedLanguage,
        platform: this.platform,
        next_block: this.next_block,
        user_id: this.userId,
        caseId: this.$route.params.case_id
      }
      this['message/send']({
        ...params,
        callback: (res) => {
          if (res.error) {
            return this.$message.error(res.error)
          }

          this.$message.success('Mensaje enviado')
          this.block_modal = false
        }
      })
    },
    createCase() {
      mixpanel.track('Composer Input: Create Case', {
        account_id: this.$route.params.account_id,
        unique_id: this.getCurrentUser().email,
        admin_id: this.getCurrentUser().email_id,
        role_id: this.getCurrentUser().role_id
      });
      const self = this
      this['case/create']({
        account_id: self.$route.params.account_id,
        admin_assigned_id: self.admin_assigned_id,
        group_id: self.group_id,
        created_by_user_id: self.userId,
        created_on_platform_id: self.platform_id,
        status: 'open',
        callback: (res) => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Caso creado')
          }
        }
      })
    },
    updateBlock(block_id, fav_value) {

      const self = this
      const block = this[fav_value ? 'blocks' : 'favorite_blocks'].find(
        (b) => b.block_id == block_id
      )

      if (!block) {
        this.$message.warning(
          'No logramos actualizar el bloque, por favor verifica tu conexión a internet'
        )
      }
      block.is_favorite = fav_value

      this['block/update']({
        account_id: self.$route.params.account_id,
        block_id,
        ...block,
        language_id: self.selectedLanguage,
        callback: (res) => {
          if (res.error) {
            this.$message.error(res.error)
          } else {
            this.$store.commit(
              `block/${fav_value ? 'pushFavorite' : 'removeFavorite'}`,
              res.resource
            )
            if (fav_value) {
              this.$message.success('Bloque agregado')
            }
          }
        }
      })
    },
    sendTyping(event) {
      if (this.typing) return

      this.typing = true
      setTimeout(() => { this.typing = false }, 6000)

      const self = this
      let params

      if (this.isForCases) {
        params = {
          account_id: self.$route.params.account_id,
          case_id: self.$route.params.case_id
        }
      } else {
        params = {
          account_id: self.$route.params.account_id,
          user_id: self.userId,
          platform: self.platform
        }
      }

      this['inbox/typing']({
        ...params,
        callback: (res) => {
          if (res.error) return self.$message.error(res.error)
        }
      })
    },
    showGuideText() {
      const userMessage =
        'Escribir mensaje. Shift + Enter para agregar nueva linea'
      const whatsappTemplateToContactClient =
        'Han transcurrido más de 24 horas.'

      return this.blockInputAfter24Hours
        ? whatsappTemplateToContactClient
        : userMessage
    }
  },
  watch: {
    block_modal(val) {
      if (
        this.$store.state.flow &&
        this.$store.state.flow.flows &&
        this.$store.state.flow.flows.length
      ) { return }
      this['flow/all']({
        account_id: this.$route.params.account_id,
        callback: (res) => {
          if (res.error) {
            this.$message.error(res.error)
          }
        }
      })
      this['block/favorites']({
        account_id: this.$route.params.account_id,
        callback: (res) => {
          this.hideLoadingScreen()
          if (res.error) {
            this.$message.error(res.error)
          }
        }
      })
    },
    response_search(val) {
      this.response_pagination.page = 1
      this.responses_hasNextPage = false

      return val ? this.searchResponse() : this.getResponses()
    },
    responsesModal(value) {
      if (value == true) {
        this.getResponses()
      }
    },
    message: function () {
      const regex = /^\/[A-Za-z0-9\s]+$/gi
      const { message = '' } = this

      this.isShown = [message.match(regex), message === '/'].some(Boolean)
    },
  },
  mounted() {
    EventBus.$on('urlPayment', ({ orderSummary, url }) => {
      this.message = `${orderSummary}\n${url}`
    })
    this.$root.$on('bv::dropdown::hide', (bvEvent) => {
      if (this.emojiPicked) {
        this.$nextTick(() => {
          this.$root.$emit('bv::show::popover', 'emoji-icon')
          this.emojiPicked = false
        })
      }
    })

    this.composerInput = document.getElementById('user-message-input')

    document
      .getElementById('user-message-input')
      .addEventListener('paste', function (e) {
        // cancel paste
        e.preventDefault()
        // get text representation of clipboard
        const text = (e.originalEvent || e).clipboardData.getData('text/plain')
        // insert text manually
        document.execCommand('insertHTML', false, text)
      })
  },
  unmounted() {
    EventBus.$off('urlPayment')
  },
  components: {
    Picker,
    'k-select': Select,
    SendWhatsappTemplate,
    SlashCommands
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/colors.scss';

#slash {
  bottom: 40px;
  width: 99%;
}

#stopIcon {
  animation: pulse 1s ease 1s infinite;
  background: --primary;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(166,194,255, 0.4);
  }
  70% {
    box-shadow: 0 0 0 1.5px rgba(166,194,255, 0.7);
  }
  100% {
    box-shadow: 0 0 0 3px rgba(166,194,255, 0.9);
  }
}

#user-message-input {
  //width: 100%;
  //min-height: 38px;
  //max-height: 68px;
  //border: 1px solid $message-bg;
  //border-radius: 5px;
  //padding: 6px;
  //overflow: hidden;
  //overflow-y: auto;
  &.short {
    max-height: 38px;
  }

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background: #f2f2f2;
    border-radius: 5px;
  }

  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 5px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #ccc;
  }

  &[placeholder]:empty::before {
    content: attr(placeholder);
    color: #6e84a3;
  }

  &[placeholder]:empty:focus::before {
    content: '';
  }
}
</style>
